import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PostHogProvider } from "@posthog/react";
import {initializedFirebaseApp} from "./Firebase";
import { getAnalytics } from "firebase/analytics";
import App from "./App";

import mixpanel from "mixpanel-browser";

const POSTHOG_API_KEY = "phc_Ur1wgZEQcmU7c5NI6d5NTe83kmXlQOtbDrgp8su4pHz";
const POSTHOG_OPTIONS = {
    api_host: "https://us.i.posthog.com",
    defaults: "2026-01-30",
};


// Near entry of your product, init Mixpanel
mixpanel.init("0cd8b639c500d2f90b33084bdf33efd9", {
    debug: false,
    track_pageview: true,
    persistence: "cookie",
    ignore_dnt: true,
});

getAnalytics(initializedFirebaseApp);


const root = createRoot(document.getElementById('root'));
root.render(
    <StrictMode>
        <PostHogProvider apiKey={POSTHOG_API_KEY} options={POSTHOG_OPTIONS}>
            <App />
        </PostHogProvider>
    </StrictMode>
);
